/* eslint-disable camelcase */
import React from 'react';
import { Link } from 'react-router-dom';
import { TableActions, ColorBatch } from 'components';
import { creditsStatusName, creditStatusColorMap, dateFormat } from 'enums';
import { convertToAdditionalCurrency, canEnterPayment } from 'utils';
import { detailsBtn } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var creditListColumns = function creditListColumns(windowWidth, userInfo) {
  return [{
    name: 'Номер',
    render: function render(_ref) {
      var id = _ref.id,
          number = _ref.number;
      return ___EmotionJSX(Link, {
        to: "credits/details/".concat(id)
      }, number);
    },
    width: '110px'
  }, {
    name: 'Сума',
    render: function render(_ref2) {
      var amount = _ref2.amount,
          currency = _ref2.currency;
      return ___EmotionJSX("span", null, amount, " ", currency, " ", ___EmotionJSX("br", null), " ", convertToAdditionalCurrency({
        value: amount,
        fromCurrency: currency
      }));
    }
  }, {
    name: 'Срок',
    render: function render(_ref3) {
      var period_months = _ref3.period_months;
      return ___EmotionJSX("span", null, period_months, " \u043C.");
    },
    width: '70px',
    invisibleBelow: 1600
  }, {
    name: 'Създаден на',
    value: 'date',
    dateTimeFormat: dateFormat,
    width: '120px',
    invisibleBelow: 1600
  }, {
    name: 'Следваща вноска',
    value: 'next_payment_date',
    dateTimeFormat: dateFormat,
    width: '120px',
    invisibleBelow: 1600
  }, {
    name: 'Вноска',
    render: function render(_ref4) {
      var next_payment_amount = _ref4.next_payment_amount,
          currency = _ref4.currency;
      return ___EmotionJSX("span", null, next_payment_amount, " ", currency, " ", windowWidth > 1600 ? ___EmotionJSX("br", null) : '/', convertToAdditionalCurrency({
        value: next_payment_amount,
        fromCurrency: currency
      }));
    },
    invisibleBelow: 1600
  }, {
    name: 'Погасено',
    render: function render(_ref5) {
      var total_payed_amount = _ref5.total_payed_amount,
          currency = _ref5.currency;
      return ___EmotionJSX("span", null, total_payed_amount, " ", currency, " ", ___EmotionJSX("br", null), convertToAdditionalCurrency({
        value: total_payed_amount,
        fromCurrency: currency
      }));
    }
  }, {
    name: 'Остава',
    render: function render(_ref6) {
      var total_amount_to_be_payed = _ref6.total_amount_to_be_payed,
          currency = _ref6.currency;
      return ___EmotionJSX("span", null, total_amount_to_be_payed, " ", currency, " ", ___EmotionJSX("br", null), convertToAdditionalCurrency({
        value: total_amount_to_be_payed,
        fromCurrency: currency
      }));
    }
  }, {
    name: 'Статус',
    render: function render(_ref7) {
      var status = _ref7.status;
      return ___EmotionJSX(ColorBatch, {
        type: creditStatusColorMap[status]
      }, creditsStatusName[status]);
    },
    width: '90px'
  }, {
    name: 'Действие',
    render: function render(credit) {
      return ___EmotionJSX(TableActions, {
        mainAction: {
          linkTo: {
            pathname: "/credits/details/".concat(credit === null || credit === void 0 ? void 0 : credit.id),
            state: {
              credit: credit
            }
          },
          leftIcon: {
            iconName: 'la la-info',
            size: 20
          },
          css: detailsBtn
        },
        actionsList: [canEnterPayment(credit, userInfo) && {
          label: 'Въведи вноска',
          linkTo: {
            pathname: "/credits/payment/".concat(credit === null || credit === void 0 ? void 0 : credit.id),
            state: {
              credit: credit
            }
          }
        }]
      });
    },
    width: '90px'
  }];
};